export default {
    message: {
        unopen: '¡aún no está abierto!',
    },
};